import axios from "axios";
import { tokenStorage } from "./tokenStorage";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = tokenStorage.get();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const createLead = (payload) => api.post("/leads", payload).then((r) => r.data);
export const adminLogin = (email, password) =>
  api.post("/auth/login", { email, password }).then((r) => r.data);
export const fetchLeads = () => api.get("/leads").then((r) => r.data);
export const fetchLead = (id) => api.get(`/leads/${id}`).then((r) => r.data);
export const updateLeadStatus = (id, status) =>
  api.patch(`/leads/${id}/status`, { status }).then((r) => r.data);
export const deleteLead = (id) => api.delete(`/leads/${id}`).then((r) => r.data);
export const resendLeadEmail = (id) =>
  api.post(`/leads/${id}/resend-email`).then((r) => r.data);
export const fetchStats = () => api.get("/leads/stats/overview").then((r) => r.data);
export const exportXlsxUrl = () => `${API}/leads/export/xlsx`;
export const aiGenerateStyles = (imageBase64) =>
  withRetry(() =>
    api
      .post("/ai/generate-styles", { image_base64: imageBase64 }, { timeout: 180000 })
      .then((r) => r.data)
  );
export const aiDiagnoseFacade = (imageBase64) =>
  withRetry(() =>
    api
      .post("/ai/diagnose-facade", { image_base64: imageBase64 }, { timeout: 100000 })
      .then((r) => r.data)
  );
export const aiChat = (sessionId, messages) =>
  api
    .post("/ai/chat", { session_id: sessionId, messages }, { timeout: 60000 })
    .then((r) => r.data);
export const aiApplyOptions = (payload) =>
  withRetry(() =>
    api.post("/ai/apply-options", payload, { timeout: 180000 }).then((r) => r.data)
  );

function withRetry(fn, { retries = 1, delayMs = 1200 } = {}) {
  return (async () => {
    let lastErr;
    for (let i = 0; i <= retries; i += 1) {
      try {
        return await fn();
      } catch (e) {
        lastErr = e;
        const status = e?.response?.status;
        // Only retry on transient errors (5xx gateway/timeout/rate-limit)
        const transient = !status || [429, 500, 502, 503, 504, 524].includes(status);
        if (!transient || i === retries) break;
        await new Promise((r) => setTimeout(r, delayMs));
      }
    }
    throw lastErr;
  })();
}

// Message d'erreur explicite en français pour les échecs des appels IA.
export function aiErrorMessage(e) {
  const status = e?.response?.status;
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string" && detail) return detail;
  if (e?.code === "ECONNABORTED")
    return "L'analyse a pris trop de temps. Vérifiez votre connexion puis réessayez.";
  if (status === 413)
    return "Photo trop volumineuse. Réduisez sa taille puis réessayez.";
  if (!status)
    return "Connexion au serveur impossible. Vérifiez votre réseau puis réessayez.";
  return "Le service IA est momentanément indisponible. Réessayez dans quelques instants.";
}
